import { useEffect } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

import { Member, Role } from '@tribeplatform/gql-client/types'

import {
  generateMemberVerificationUrl,
  isMemberNotConfirmed,
  isUrlPointsWithinApp,
} from '../../utils/permission.utils.js'

export const useRedirectUnconfirmedUser = (
  member: Member,
  role: Role,
): void => {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (isMemberNotConfirmed(member, role) && isUrlPointsWithinApp(pathname)) {
      navigate(generateMemberVerificationUrl(member.id))
    }
  }, [pathname, member, role, navigate])
}
